import { styled } from "@mui/material";

import makeStyles from "@mui/styles/makeStyles";

type StyleProps = {
  color?: string;
  colorSelected?: string;
  borderColor?: string;
};

export const DivWithBackground = styled("div")<StyleProps>(
  ({ color, colorSelected, borderColor }) => ({
    background: color,
    width: "24px",
    height: "24px",
    borderRadius: "999px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    cursor: "pointer",
    border: color === colorSelected ? `3px solid ${borderColor}` : "none",
  })
);

const styles = makeStyles(() => ({
  sectionColor: {
    display: "flex",
    width: "100%",
    flexWrap: "wrap",
    gap: "10px",
    marginTop: "0.5rem",
    marginBottom: "0.5rem",
  },

  formHelper: {
    fontFamily: "Manrope",
    fontStyle: "normal",
    fontWeight: "normal",
    fontSize: "14px",
    lineHeight: "24px",
    color: "#D92D20",
    alignItems: "center",
    display: "flex",
    margin: 0,
  },

  iconError: {
    marginRight: "5px",
    fontSize: "16px",
  },
}));

export default styles;
